import * as React from 'react'
import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { LogIn } from 'react-feather'
import { t } from 'i18next'
import { useTheme } from '@mui/material/styles'
import { useCallback } from 'react'
import { useAppDispatch } from '../../store/utils/hooks'
import { actionResetUserState } from '../../store/slices/user/userSlice'
import { useNavigate } from 'react-router-dom'
import { userSignOut } from '../../utils/Firebase/methods'
import { LOGIN_PATH } from '../../routes/LoginRoutes'

type ManVsMachineCheckoutLayoutProps = {
	children: React.ReactNode
}

export default function ManVsMachineCheckoutLayout({ children }: ManVsMachineCheckoutLayoutProps) {
	const { palette } = useTheme()
	const navigate = useNavigate()
	const dispatch = useAppDispatch()

	const signOut = useCallback(async () => {
		await userSignOut()
		dispatch(actionResetUserState())
	}, [dispatch])

	const navigateLogin = useCallback(async () => {
		await signOut()
		navigate(LOGIN_PATH)
	}, [navigate, signOut])

	return (
		<Stack sx={{ height: '100vh' }}>
			<Box sx={{ display: 'flex', alignItems: 'center', padding: '30px' }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={`${process.env.PUBLIC_URL}/assets/images/new_prop_p.svg`}
						alt="Logo"
						style={{ maxWidth: '100%', height: '25px' }}
					/>
					<Typography
						component="h1"
						sx={{
							fontFamily: '"Eczar", serif',
							fontSize: '24px',
							color: palette.text.darkBlue,
							fontWeight: '500',
							ml: 1,
						}}
					>
						{t('prop_ai')}
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', margin: '0 0 0 auto', color: palette.text.darkBlue }}>
					<Button variant="text" onClick={navigateLogin}>
						<LogIn />
						<Typography marginLeft="8px" fontSize="14px" fontWeight="bold">
							{t('onboarding.layout.sign_in_button_label')}
						</Typography>
					</Button>
				</Box>
			</Box>
			<Grid container sx={{ marginBottom: 'auto', flexGrow: 1, alignItems: 'center' }}>
				<Grid item xs={1} />
				<Grid item xs={10}>
					{children}
				</Grid>
				<Grid item xs={1} />
			</Grid>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '20px',
					borderTop: `1px solid ${palette.sidebar.borderGray}`,
					color: palette.text.darkGrey,
					fontSize: '12px',
				}}
			>
				<Stack direction="row" spacing={3}>
					<Typography>{t('onboarding.layout.contact_us_link_label')}</Typography>
					<Typography>{t('onboarding.layout.privacy_and_terms_link_label')}</Typography>
					<Typography>{t('onboarding.layout.trademark_link_label')}</Typography>
				</Stack>
			</Box>
		</Stack>
	)
}
